/**
 * Class maps for the filter design tokens.
 *
 * These are written out as complete literal strings on purpose: Tailwind scans
 * source text, so a class assembled at runtime (`bg-accent-${accent}`) would
 * never make it into the stylesheet.
 */

/** Section identity. Lives in the icon tile and the rail — never in a selected option (§23.5). */
export type SectionAccent = "blue" | "purple" | "green" | "orange" | "cyan";

export const ACCENT_TILE: Record<SectionAccent, string> = {
  blue: "bg-accent-blue/[0.14] text-accent-blue-ink",
  purple: "bg-accent-purple/[0.14] text-accent-purple-ink",
  green: "bg-accent-green/[0.14] text-accent-green-ink",
  orange: "bg-accent-orange/[0.14] text-accent-orange-ink",
  cyan: "bg-accent-cyan/[0.14] text-accent-cyan-ink",
};

/**
 * How many options a section shows before an overflow control appears, and the
 * single escalation ladder that follows (§23.7). One affordance is visible at
 * any time — never a `+N mais` and a `Ver todas` and an arrow together.
 */
export const VISIBLE_OPTIONS = 12;

export type OverflowMode = "none" | "inline" | "modal";

export function overflowMode(total: number): OverflowMode {
  if (total <= VISIBLE_OPTIONS) return "none";
  if (total <= VISIBLE_OPTIONS * 2) return "inline";
  return "modal";
}

/** Focus ring shared by every interactive element in the filter (§55). */
export const FOCUS_RING =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-select/60 focus-visible:ring-offset-2 focus-visible:ring-offset-surface";

export function cx(...values: Array<string | false | null | undefined>): string {
  return values.filter(Boolean).join(" ");
}
